import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, BaasicFormControls, BasicTextArea, BaasicButton, DatePickerField, BasicCheckbox, BaasicModal } from 'core/components';
import { observer } from 'mobx-react';
import { FacilityOrderPatientNewFlowInsuranceInsuranceEditTemplate } from "themes/application/facility-order-new-flow-insurance/components";
import { RelationshipChangeModal } from 'application/facility-order-new-flow-insurance/components';

function FacilityOrderPatientNewFlowInsuranceNoteModalTemplate({ facilityOrderPatientNewFlowInsuranceNoteModalStore, t }) {
    const {
        tabItems,
        selectedTabItemAbrv,
        setTabItem,
        form,
        modalParams,
        eligibilityStatusStore,
        facilityOrderTemplates,
        isEligibleInsuranceStatus,
        showTemplates,
        changeTemplatesVisibility,
        patient,
        facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore,
        relationshipChangeModal
    } = facilityOrderPatientNewFlowInsuranceNoteModalStore;

    const tabButtons = tabItems ? tabItems.map(item =>
        <BaasicButton key={item.abrv}
            disabled={form.submitting || form.validating}
            className={"tabs__item " + (item.abrv == selectedTabItemAbrv ? 'active' : '')}
            label={item.name}
            onClick={() => item.abrv != selectedTabItemAbrv ? setTabItem(item.abrv) : {}}
        />
    ) : null;

    return (
        <div style={{ minHeight: 280 }}>
            <div className="modal__header">
                <h3 className='modal__header__title'>Reason for Change / Review</h3>
            </div>
            <div className="modal__body">
                <div className="u-mar--bottom--sml">
                    <h3 className='modal__header__title u-mar--bottom--sml'>
                        {patient && patient.lastName && `${patient.lastName}`}
                        {patient && patient.lastName && patient.firstName && ', '}
                        {patient && patient.firstName && `${patient.firstName}`}
                    </h3>
                </div>
                <div className="tabs u-mar--bottom--med">
                    {tabButtons}
                </div>
                {selectedTabItemAbrv === 'insurance-eligibility' ?
                    <div className="row">
                        <div className="col col-sml-6 form__group u-mar--bottom--sml--alt">
                            <BaasicFieldDropdown field={form.$('eligibilityId')} store={eligibilityStatusStore} allowEmpty={true} disabled={form.submitting || form.validating}/>
                        </div>
                        <div className="col col-sml-6 form__group u-mar--bottom--sml--alt">
                            <DatePickerField field={form.$('effectiveDate')} disabled={form.submitting || form.validating}/>
                        </div>
                        {isEligibleInsuranceStatus &&
                            <div className="col col-sml-12 form__group u-mar--bottom--sml--alt">
                                <div className="card--insurance-template">
                                    <div className="u-flex--space-between u-flex--grow--1" style={{ cursor: "pointer" }} onClick={() => { if (form.submitting || form.validating) return; changeTemplatesVisibility() }}>
                                        <label>{`PAR ${facilityOrderTemplates.filter(fot => fot.isPriorAuthNeeded).length > 0 ? `${facilityOrderTemplates.filter(fot => fot.isPriorAuthNeeded).length}/${facilityOrderTemplates.length}` : ''}`}</label>
                                        <i className={"u-icon u-icon--xsml " + (showTemplates ? "u-icon--arrow-up" : "u-icon--arrow-down") + " u-mar--left--sml"} />
                                    </div>

                                    {showTemplates && facilityOrderTemplates.map(item => {
                                        return (<FacilityOrderTemplateTable key={item.id} facilityOrderPatientNewFlowInsuranceNoteModalStore={facilityOrderPatientNewFlowInsuranceNoteModalStore} facilityOrderTemplate={item} />);
                                    })}
                                </div>
                            </div>
                        }
                        <div className="col col-sml-12 form__group u-mar--bottom--sml--alt">
                            <BasicTextArea field={form.$('note')} rows={1} disabled={form.submitting || form.validating} />
                        </div>
                    </div>
                    :
                    <FacilityOrderPatientNewFlowInsuranceInsuranceEditTemplate
                        facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore={facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore}
                        disabled={form.submitting || form.validating}
                        disableForm={form.submitting || form.validating}
                    />
                }
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    disabled={form.submitting || form.validating}
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicFormControls
                    className='btn btn--med btn--primary'
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    label="Submit"
                />
            </div>

            <BaasicModal modalParams={relationshipChangeModal} className="modal__content modal--med">
                <RelationshipChangeModal />
            </BaasicModal>
        </div>
    )
}

const FacilityOrderTemplateTable = observer(({ facilityOrderPatientNewFlowInsuranceNoteModalStore, facilityOrderTemplate }) => {
    const {
        setPriorAuthNeededd,
        changeItemsVisibility,
        form
    } = facilityOrderPatientNewFlowInsuranceNoteModalStore;

    return (
        <div className="table--secondary__wrapper u-mar--top--sml is-add-new-disabled">
            <table width="100%" className="table--secondary">
                <colgroup>
                    <col width="250*" />
                    <col width="250*" />
                    <col width="250*" />
                </colgroup>
                <thead>
                    <tr>
                        <th colSpan={"3"}>
                            <div className='u-flex--default u-flex--align-items--center'>
                                <div>
                                    <BasicCheckbox id={facilityOrderTemplate.id} checked={facilityOrderTemplate.isPriorAuthNeeded} onChange={() => setPriorAuthNeededd(facilityOrderTemplate)} disabled={form.submitting || form.validating} />
                                </div>
                                <div className="u-flex--space-between u-flex--grow--1" style={{ cursor: "pointer" }}   onClick={
                                    form.submitting || form.validating
                                    ? undefined
                                    : () => changeItemsVisibility(facilityOrderTemplate)
                                }>
                                    <label>{facilityOrderTemplate.subCategory.name.toUpperCase()}</label>
                                    <i className={"u-icon u-icon--xsml " + (facilityOrderTemplate.itemsVisible ? "u-icon--arrow-up" : "u-icon--arrow-down") + " u-mar--left--sml"} />
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {facilityOrderTemplate.itemsVisible &&
                        <tr>
                            <td><span className="type--sml type--wgt--bold type--color--primary">ITEM NAME</span></td>
                            <td><span className="type--sml type--wgt--bold type--color--primary">ITEM ID</span></td>
                            <td><span className="type--sml type--wgt--bold type--color--primary">PROCEDURE CODE</span></td>
                        </tr>}
                    {facilityOrderTemplate.itemsVisible && facilityOrderTemplate.facilityOrderTemplateItems.map((item) => {
                        return (
                            <tr key={item.id} >
                                <td>
                                    {item.product && item.product.description}
                                </td>
                                <td>
                                    {item.product && item.product.itemId}
                                </td>
                                <td>
                                    {item.product && item.product.procedureCode_.abrv}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
});

FacilityOrderTemplateTable.propTypes = {
    facilityOrderTemplateNewFlowInsuranceEditViewStore: PropTypes.object.isRequired,
    facilityOrderTemplate: PropTypes.object.isRequired
};

FacilityOrderPatientNewFlowInsuranceNoteModalTemplate.propTypes = {
    facilityOrderPatientNewFlowInsuranceNoteModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderPatientNewFlowInsuranceNoteModalTemplate);
